import { Injectable, OnDestroy } from "@angular/core";
import { Observable, of } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { ActionCoCardModel, ActionCoHistory, Person } from "../../../models";
import { CoreService, HttpService } from "../../../services";
import { ActionCoService } from "./action-co.service";

@Injectable()
export class ActionCoHistoService implements OnDestroy {

  constructor(
    protected http: HttpService,
    protected indParam: CoreService,
    protected actionCoService: ActionCoService,
  ) {}

  //#region Get Type Histo
  private typeHistoModel: ActionCoCardModel = new ActionCoCardModel();
  private isTypeHistoDirty = true;

  public GetTypeHisto(forceReload: boolean = false): Observable<ActionCoCardModel> {
    if (!this.isTypeHistoDirty && !forceReload) {
      return of(this.typeHistoModel);
    } else {
      return this.http.getHttp<ActionCoCardModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Card/GET_TYPE_HISTO/0/`).pipe(
        mergeMap((data: ActionCoCardModel) => {
          this.typeHistoModel = data;
          this.isTypeHistoDirty = false;
          return of(this.typeHistoModel);
        })
      );
    }
  }
  //#endregion

  //Temporaire a refaire mieux 
  public GetReasonHisto() {
    this.http.getHttp<ActionCoCardModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Card/GET_LOSE_REASONS/0/`).subscribe(
      (result: ActionCoCardModel) => {
        this.actionCoService.Model.ReasonsList = result.ReasonsList;
      });
  }

  public SaveHistory(histories: Array<ActionCoHistory>, addContact: boolean): Observable<ActionCoCardModel> {
    
    const model: ActionCoCardModel = new ActionCoCardModel();
    model.Mode = "SET_HISTORY_BY_ID_ACTION_CO";
    model.idActionCo = this.actionCoService.Model.idActionCo;
    model.Customer = this.actionCoService.Model.Customer;
    model.ContactPrincipal = addContact ? this.actionCoService.Model.ContactPrincipal : new Person();
    model.History = histories;
    return this.http.postHttp<ActionCoCardModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Card/`, model).pipe(
      mergeMap((data: ActionCoCardModel) => {
        this.GetHistory();
        return of(data);
      }));
  }

  public GetHistory(): void {
    this.http.getHttp<ActionCoCardModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Card/GET_HISTORY_BY_ID_ACTION_CO/${this.actionCoService.Model.idActionCo}/`).subscribe(
      (data: ActionCoCardModel) => {
        this.actionCoService.Model.History = data.History;
      });
  }




  ngOnDestroy(): void {
  }


}
